<template>
  <aside
    class="h-full max-h-full w-56 overflow-hidden card flex-shrink-0 flex-grow-0 flex flex-col"
  >
    <PanelTitle title="REDCap Projects" />
    <div class="p-3 h-full max-h-full overflow-hidden flex flex-col">
      <div v-if="!isDemo" class="mt-2">
        <Button
          @click="$emit('update:addingNewProject', true)"
          :disabled="addingNewProject"
          theme="secondary"
          size="sm"
          stretch
          :title="addingNewProject ? 'You are already adding a project' : ''"
        >
          Add Project
        </Button>
      </div>
      <div
        v-if="projects.length > 0"
        class="h-full max-h-full overflow-y-scroll border-gray-300 mt-2 rounded"
        id="project-wrapper"
      >
        <div
          v-for="(project, i) in projects"
          :key="project.name"
          :class="[
            'cursor-pointer p-2 rounded selectable',
            {
              selected: selectedProject?.id === project.id,
              'mt-2': i > 0
            }
          ]"
        >
          <Text @click="selectProject(i)" class="selectable">
            {{ project.name }}
          </Text>
        </div>
      </div>
      <Text v-else align="center" class="p-2">
        No Projects synced
      </Text>
    </div>
  </aside>
</template>

<script setup>
// import { ref, watch, computed } from "vue"
// import ApiClient from '../services/ApiClient.js'

import Text from "./Text.vue"
import Button from "./Button.vue"
import PanelTitle from "./PanelTitle.vue"

const emit = defineEmits(["select-project", "update:addingNewProject"])

defineProps({
  projects: {
    type: Array,
    required: true
  },
  selectedProject: {
    type: [Object, null],
    required: true
  },
  addingNewProject: {
    type: Boolean,
    required: false
  }
})

const isDemo = __DEMO_MODE__

function selectProject(idx) {
  emit("select-project", idx)
}
</script>

<style scoped>
.selected {
  background: rgb(239, 246, 255);
}
</style>
